import type { CycleCountConfig } from '../models/cycle-count-config.model';

export type CycleCountLandingState = 'no-warehouse' | 'no-pending' | 'pending';

export const CYCLE_COUNT_SESSION_ROUTE = '/page-cycle-count-session';

export function isCycleCountSessionExit(
  previousUrl: string | null | undefined,
  currentUrl: string | null | undefined
): boolean {
  if (!previousUrl || !currentUrl) return false;
  return (
    previousUrl.startsWith(CYCLE_COUNT_SESSION_ROUTE) &&
    !currentUrl.startsWith(CYCLE_COUNT_SESSION_ROUTE)
  );
}

export function isPendingCycleCount(
  config: CycleCountConfig | null | undefined
): boolean {
  if (!config) return false;
  return !!config.cycleCountId && config.cycleCountStatus === 'Draft';
}

export function findPendingCycleCountForWarehouse(
  configs: CycleCountConfig[] | null | undefined,
  warehouseId: number | null | undefined
): CycleCountConfig | null {
  if (warehouseId == null) return null;
  if (!configs?.length) return null;
  const match = configs.find((c) => c.warehouseId === warehouseId);
  return match && isPendingCycleCount(match) ? match : null;
}

export function getPendingCycleCountBadge(
  configs: CycleCountConfig[] | null | undefined,
  warehouseId: number | null | undefined
): string | null {
  const pending = findPendingCycleCountForWarehouse(configs, warehouseId);
  return pending?.cycleCountStatus ?? null;
}

export function getCycleCountLandingState(
  warehouseId: number | null | undefined,
  pending: CycleCountConfig | null
): CycleCountLandingState {
  if (warehouseId == null) return 'no-warehouse';
  return pending ? 'pending' : 'no-pending';
}

export function formatPendingSessionGeneratedAt(
  iso: string | null | undefined
): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  // "month, day, year" (#31383), rendered against the UTC calendar day so the
  // session card stays stable regardless of the viewer's time zone.
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
